module.exports = __webpack_public_path__ + "static/00009.acdfe77a.jpg";